"use strict";function create$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.create$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.ding.create";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.5.1",resultDeal:function(e){return""===e?e={dingCreateResult:!1}:"object"==typeof e&&(e.dingCreateResult=!!e.dingCreateResult),e}},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.5.1"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.5.9"},_a)),exports.create$=create$,exports.default=create$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/ding/create.js
// module id = 944
// module chunks = 106